/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_PriorityInputs */

const cs_col_priority = /** @type {(inputs: Col_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorita`)
};

const en_col_priority = /** @type {(inputs: Col_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Col_PriorityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_priority = /** @type {((inputs?: Col_PriorityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_PriorityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_priority(inputs)
	return cs_col_priority(inputs)
});